module.exports = __webpack_public_path__ + "img/Sec_Study_man2.89ee5390.jpg";